import React from 'react';

import { CloseOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';

import BaseIconButton from '../../../Buttons/BaseIconButton';
import { DismissPillProps } from './types';
import { getDissmissPillClasses } from './utils';

const DismissPill = React.forwardRef<HTMLButtonElement, DismissPillProps>((props, ref) => {
  const { appearance, className, size, ...rest } = props;
  const classes = getDissmissPillClasses(size, appearance);

  return (
    <BaseIconButton ref={ref} className={cn(classes.root, className)} {...rest}>
      <CloseOutline className={classes.icon} />
    </BaseIconButton>
  );
});

export default DismissPill;
